/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Deleteattemptdescription2Inputs */

const zh_learn_deleteattemptdescription2 = /** @type {(inputs: Learn_Deleteattemptdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这会永久删除这条作答记录及其完成记录，且无法撤销。`)
};

const en_learn_deleteattemptdescription2 = /** @type {(inputs: Learn_Deleteattemptdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently delete this attempt and its completion records. This action cannot be undone.`)
};

const es_learn_deleteattemptdescription2 = /** @type {(inputs: Learn_Deleteattemptdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto eliminará permanentemente este intento y sus registros de finalización. Esta acción no se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "This will permanently delete this attempt and its completion records. This action cannot be undone." |
*
* @param {Learn_Deleteattemptdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_deleteattemptdescription2 = /** @type {((inputs?: Learn_Deleteattemptdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Deleteattemptdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_deleteattemptdescription2(inputs)
	if (locale === "en") return en_learn_deleteattemptdescription2(inputs)
	return es_learn_deleteattemptdescription2(inputs)
});
export { learn_deleteattemptdescription2 as "learn_deleteAttemptDescription" }